import './home.css';
import { BannerImageData } from '../../dummyData/bannerCarouselData';
import TabsBar from '../../webPageSections/tabsBar/TabsBar';
import BannerCarousel from '../../components/bannerCarousel/BannerCarousel';
import LetsGo from '../../assets/images/trvto_letsgo.svg';
import { useState, useEffect } from 'react';
import WhyUsSection from './whyus/WhyUsCom';
import DiscountSection from './discount/DiscountCom';
import DestinationSection from './destination/DestinationCom';
import ReviewSection from './review/ReviewCom';
import BlogSection from './blog/BlogCom';
import SeoSection from './seo/SeoCom';
import Backpacking from '../../webPageSections/tabsBar/searchComponents/backpack';
import Camp from '../../webPageSections/tabsBar/searchComponents/camp';
import AdventureSection from './adventure/AdventureCom';
import ExoticSection from './exotic/ExoticCom';
import { useTempOrg } from '../../context/TempOrgContext';
import { clearBookingStorage } from '../../utils/clearStorage';
import OffersSection from './offers/OffersSection';
import Guide from '../../webPageSections/tabsBar/searchComponents/guide';
import Activity from '../../webPageSections/tabsBar/searchComponents/activity';
import SpecialOfferTrips from '../../components/SpecialOfferTrips/SpecialOfferTrips';

function Home() {
    const [selectOption, setSelectOption] = useState('trip');
    const { setTempOrg } = useTempOrg();
    const handleType = (e) => {
        setSelectOption(e.target.value);
    };
    useEffect(() => {
        // Clear tempOrg from context (automatically updates localStorage)
        setTempOrg({});
        clearBookingStorage();
        // Broadcast removal to other tabs/components
        const channel = new BroadcastChannel('org_channel');
        channel.postMessage({ type: 'REMOVE_ORG', payload: {} });

        // Cleanup
        return () => channel.close();
    }, [setTempOrg]);
    return (
        <div>
            <BannerCarousel className='homePage' imageData={BannerImageData?.data} />

            <div className='bannerWrapper mobHidden'>
                <div className='bannerTitle'>
                    <img src={LetsGo} alt='trvto_lets go' loading='lazy' decoding='async' />
                    <h1>Unleash the Adventure in You!</h1>
                </div>
                <TabsBar />
            </div>
            <div className='mobDisplay'>
                <div className='customContainer'>
                    <div className='searchCard'>
                        <select value={selectOption} name='type' onChange={(e) => handleType(e)} className='homeSearch'>
                            <option value='Select'>Select</option>
                            <option value='trip'>Trip</option>
                            <option value='camp' disabled>
                                Camp
                            </option>
                            <option value='activity' disabled>
                                Activity
                            </option>
                            <option value='guide' disabled>
                                Guide
                            </option>
                        </select>
                        {selectOption === 'trip' && <Backpacking />}
                        {selectOption === 'camp' && <Camp />}
                        {selectOption === 'activity' && <Activity />}
                        {selectOption === 'guide' && <Guide />}
                    </div>
                </div>
            </div>
            <SpecialOfferTrips />
            <OffersSection />
            <DestinationSection />
            <AdventureSection />
            <ExoticSection />
            <DiscountSection />
            <WhyUsSection />
            <ReviewSection />
            <BlogSection />
            <SeoSection />
        </div>
    );
}

export default Home;
